/**
 * useIsSuperAdmin
 *
 * Returns true when the currently-authenticated user's email matches
 * the super-admin whitelist in `@aiga/app-config/security`.
 * Used to gate the sidebar Developer tab and the developer-only
 * /devtools/error-reports page. The backend reads the same whitelist
 * for authorization so visibility and authorization can't diverge.
 */

import { useAuth } from '../contexts/AuthContext';
import { isSuperAdminEmail } from '@aiga/app-config/security';

export function useIsSuperAdmin(): boolean {
  const { user } = useAuth();
  return isSuperAdminEmail(user?.email);
}
